import { mobileProductSchema } from './mobile-product.schema';
import { webProductSchema } from './web-product.schema';
import { z } from 'zod/v4';

export const companyProductsSchema = z.object({
  mobileProducts: z.array(mobileProductSchema),
  webProducts: z.array(webProductSchema),
});

export type CompanyProducts = z.infer<typeof companyProductsSchema>;
